import { useEffect, useRef } from 'react';
import { useVideoCallStore } from '../videocall.zustandstore';
import { GetStreamHandler } from '../GetstreamHandler';
import { CUSTOM_EVENTS } from '../../../utils/constants';

const useCreateGSClient = () => {
    const getstreamHandler = useRef(new GetStreamHandler());
    const { setClient } = useVideoCallStore();

    useEffect(() => {
        const gsHandler = getstreamHandler.current;
        const controller = new AbortController();
        const createGSClient = (e) => {
            setTimeout(async () => {
                if (e.detail.userData) {
                    // console.log({uData: e.detail.userData});
                    const { userId, firstName } = e.detail.userData;
                    const { err, client } = await gsHandler.getClient({ userId, name: firstName });
                    // console.log({client});
                    if (!err) {
                      setClient(client);
                    }
                }
            }, 1000);
        };

        document.addEventListener(CUSTOM_EVENTS.CREATE_GS_CLIENT_AFTER_LOGIN, createGSClient, { signal: controller.signal });
        return () => {
            controller.abort();
            gsHandler.destroy();
        };
    }, [setClient]);
};

export default useCreateGSClient;